var React = require('react');

function Section3TopLeftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"70.5","cy":"123.5","r":"20.5","fill":"#C5F6D5","key":0}),React.createElement("rect",{"width":"38.524","height":"38.524","x":"28","y":"80","fill":"#F58C8C","key":1}),React.createElement("polygon",{"fill":"#E7F5FF","points":"174.43 125.518 134.081 77.808 172.492 63.064","transform":"scale(-1 1) rotate(80 0 -89.544)","key":2}),React.createElement("circle",{"cx":"134.356","cy":"43.356","r":"43.356","fill":"#FEFCBE","key":3}),React.createElement("circle",{"cx":"12","cy":"13","r":"12","fill":"#E9D8FD","key":4})]));
}

Section3TopLeftInline.defaultProps = {"width":"182","height":"144","viewBox":"0 0 182 144"};

module.exports = Section3TopLeftInline;

Section3TopLeftInline.default = Section3TopLeftInline;
